
import { Component, Vue } from 'vue-property-decorator';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
import OsSheetContent from '@/components/core/sheet/OsSheetContent.vue';
import {
  AppuserState,
  IExtendedAppuser,
  IReportContentCategory,
  ReportContentCategoryState
} from '@/models/application';
import { GuidUtil } from '@/utils/GuidUtil';
import OsAppuserForm from '@/components/shared/appusers/OsAppuserForm.vue';
import { AppDirtyUtil } from '@/utils/AppDirtyUtil';
import OsInternalUserForm from '@/components/shared/internalusers/OsInternalUserForm.vue';
import { appuserApi, reportContentCategoriesApi } from '@/apis';
import OsAlertBox from '@/components/core/OsAlertBox.vue';
import OsReportContentCategoryForm from '@/components/shared/reportcontentcategories/OsReportContentCategoryForm.vue';

@Component({
  components: {
    OsReportContentCategoryForm,
    OsAlertBox,
    OsInternalUserForm,
    OsAppuserForm,
    OsSheetContent,
    OsSheet
  }
})
export default class SettingsReportContentCategoryCreate extends Vue {
  appDirtyUtil: AppDirtyUtil = new AppDirtyUtil();

  category: IReportContentCategory = {
    id: GuidUtil.empty(),
    name: '',
    state: ReportContentCategoryState.Inactive,
    sequencenumber: -1
  };

  loading = false;

  async onSave() {
    this.loading = true;
    try {
      const createdCategory = await reportContentCategoriesApi.create(
        this.category
      );

      this.appDirtyUtil.init(createdCategory);
      await this.$router.push(`/settings/reportcontentcategories/`);
    } finally {
      this.loading = false;
    }
  }
}
